import { render, staticRenderFns } from "./studentDetail.vue?vue&type=template&id=c20febe2&scoped=true"
import script from "./studentDetail.vue?vue&type=script&lang=js"
export * from "./studentDetail.vue?vue&type=script&lang=js"
import style0 from "./studentDetail.vue?vue&type=style&index=0&id=c20febe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20febe2",
  null
  
)

export default component.exports